/* eslint-disable */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Loader, Input } from "../../../../../components/ui";
import CoffeeSiteRewardsTable from "../../../../../components/parts/tables/coffeeSiteRewards";
import { ArrowLeft, Search, FileEarmarkExcel } from "react-bootstrap-icons";
import jwtInterceoptor from "../../../../../api/jwtInterceptor";
import { GET_API_URLS } from "../../../../../utils/constant";

const CoffeeSiteRewards = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState("");
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pagination, setPagination] = useState({
    limit: 10,
    offset: 0,
    total: 0,
    ordering: "-total_reedems", // Default ordering by total redeems in descending order
  });

  const fetchData = async (search = "") => {
    setLoading(true);
    setError("");
    try {
      const queryParams = new URLSearchParams({
        limit: pagination.limit,
        offset: pagination.offset,
        ordering: pagination.ordering,
        ...(search && { name: search }),
      }).toString();

      const response = await jwtInterceoptor.get(
        `${GET_API_URLS.COFFEE_STORE_REWARDS}?${queryParams}`
      );

      setTableData(response.data.results);
      setPagination((prev) => ({
        ...prev,
        total: response.data.count,
      }));
    } catch (error) {
      if (error.response?.status === 403) {
        setError("You dont have permission to access this page.");
      } else {
        setError("There was a problem while loading the data.");
      }
      console.log("Error", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [pagination.offset, pagination.limit, pagination.ordering]);

  // Debounce search to avoid too many API calls
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQuery !== "") {
        // Reset offset when searching
        setPagination((prev) => ({ ...prev, offset: 0 }));
        fetchData(searchQuery);
      } else {
        setPagination((prev) => ({ ...prev, offset: 0 }));
        fetchData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  const handlePageChange = (newOffset) => {
    setPagination((prev) => ({ ...prev, offset: newOffset }));
  };

  const handleLimitChange = (newLimit) => {
    setPagination((prev) => ({ ...prev, limit: newLimit, offset: 0 }));
  };

  const handleSort = (field) => {
    const newOrdering =
      pagination.ordering.startsWith("-") &&
      pagination.ordering.substring(1) === field
        ? field
        : `-${field}`;
    setPagination((prev) => ({ ...prev, ordering: newOrdering, offset: 0 }));
  };

  const handleExportToExcel = async () => {
    setExportLoading(true);
    try {
      // Create query params - typically we want to export all data, not just current page
      // const queryParams = new URLSearchParams({
      //   ordering: pagination.ordering,
      //   ...(searchQuery && { name: searchQuery }),
      //   export_format: "excel",
      // }).toString();

      const response = await jwtInterceoptor.get(
        `${GET_API_URLS.COFFEE_STORE_REWARDS}create_excel/`,
        { responseType: "blob" } // Important for handling binary file data
      );

      // Create a download link for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `coffee-site-rewards-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Failed to export data. Please try again.");
    }
    setExportLoading(false);
  };

  return (
    <div>
      {error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "10px 0",
            }}
          >
            <Button
              label={
                <>
                  <ArrowLeft /> Back
                </>
              }
              onClick={() => navigate(-1)}
              secondary
              style={{
                padding: "8px 16px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                width: "fit-content",
              }}
            />
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Button
                label={
                  <>
                    <FileEarmarkExcel />{" "}
                    {exportLoading ? "Exporting..." : "Export Excel"}
                  </>
                }
                onClick={handleExportToExcel}
                disabled={exportLoading}
                style={{
                  padding: "8px 16px",
                  cursor: exportLoading ? "default" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "var(--greenColor)",
                  flex: "0 0 150px",
                }}
              />
              <div style={{ width: "300px" }}>
                <Input
                  type="text"
                  placeholder="Search by store name..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  icon={<Search />}
                />
              </div>
            </div>
          </div>
          <CoffeeSiteRewardsTable
            tableData={tableData}
            pagination={pagination}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            onSort={handleSort}
            loading={loading}
          />
        </>
      )}
    </div>
  );
};

export default CoffeeSiteRewards;
